export const AllowedQuestionnaire: { [key: string]: string } = {
	radiogroup: 'Radio Button Group',
	dropdown: 'Dropdown',
	boolean: 'boolean',
};

export const QuestionnaireTypes: { [key: string]: string } = {
	radiogroup: 'radio',
};
